import { useParams } from "react-router-dom";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import { useEffect, useState } from "react";

import SpinnerSectionContent from "../../../components/spinner/spinnerSectionContent";
import TrainingEvaluasiLvl1Toolbar from "./trainingReportTel1Component/toolbar";
import Tel1ParticipantTable from "./trainingReportTel1Component/participantTable";
import Tel1EpdTemplate from "./trainingReportTel1Component/epdTemplate";
import { detailTrainingTel1 } from "../../../config/apiSPA";

function TrainingTeportTel1() {
  const { id } = useParams();
  const [isLoadingState, setIsLoadingState] = useState(true);
  const [tel1DataState, setTel1DataState] = useState();
  const [isFoundState, setIsFoundState] = useState(false);
  const onUpdate = (e) => {
    if (!e.success) {
      setIsFoundState(false);
      return;
    }
    setTel1DataState(e.data);
    setIsFoundState(true);
  };
  useEffect(() => {
    const loadData = async () => {
      setIsLoadingState(true);
      try {
        const res = await detailTrainingTel1(id);
        setTel1DataState(res.data);
        setIsFoundState(true);
      } catch (error) {
        setIsFoundState(false);
      } finally {
        setIsLoadingState(false);
      }
    };
    loadData();
  }, []);
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Training Evaluation Level 1 (Reaction)</CardHeader>
        <CardBody>
          {isLoadingState ? (
            <SpinnerSectionContent />
          ) : (
            <>
              <TrainingEvaluasiLvl1Toolbar onUpdate={(e) => onUpdate(e)} isFound={isFoundState} />
              {isFoundState ? (
                <>
                  <Tel1ParticipantTable participantData={tel1DataState.participant} />
                  <Tel1EpdTemplate epdTemplateData={tel1DataState.resume} />
                </>
              ) : (
                ""
              )}
            </>
          )}
        </CardBody>
      </Card>
    </>
  );
}
export default TrainingTeportTel1;
